import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import React from "react";
import cn from "@/app/utils/cn";
export default function NoData(t0) {
  const $ = _c(15);
  const {
    text,
    customStyle,
    image,
    width,
    height
  } = t0;
  let t1;
  if ($[0] !== customStyle) {
    t1 = cn("flex h-full w-full flex-col items-center justify-center gap-6 pb-4 md:pb-6", customStyle);
    $[0] = customStyle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = image ?? "/images/empty.png";
  const t3 = width ?? "w-20 md:w-[120px]";
  let t4;
  if ($[2] !== t3) {
    t4 = cn(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = width ?? 120;
  const t6 = height ?? 139;
  let t7;
  if ($[4] !== t2 || $[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = <Image src={t2} alt="not found" className={t4} width={t5} height={t6} />;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = text ? text : "\u0627\u0637\u0644\u0627\u0639\u0627\u062A\u06CC \u0628\u0631\u0627\u06CC \u0646\u0645\u0627\u06CC\u0634 \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F.";
  let t9;
  if ($[9] !== t8) {
    t9 = <p className="text-center text-sm md:text-base font-semibold text-charcoal-900">{t8}</p>;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t1 || $[12] !== t7 || $[13] !== t9) {
    t10 = <div className={t1}>{t7}{t9}</div>;
    $[11] = t1;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
}